/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {FetchMethod, IndexedObject} from '@dvrd/dvr-controls';

export const URLS = {
    [FetchMethod.GET]: {
        USER: 'user',
        LOGOUT: '',
        DISABLE_TWO_FACTOR: '',
        GENERATE_TWO_FACTOR: '',
    },
    [FetchMethod.POST]: {
        LOGIN: 'auth/login',
        DOWNLOAD_YT: 'yt',
    },
    [FetchMethod.PUT]: {
        USER: '',
    },
    [FetchMethod.DELETE]: {
        USER: '',
    },
};

export const createParamUrl = (url: string, params: IndexedObject<string>) => {
    const keys = Object.keys(params);
    for (const key of keys)
        url = url.replace(`{${key}}`, params[key]);
    return url;
};